import React from 'react';

// BBA interwoven mark drawn as a single continuous stroke. A small gap
// travels the line forever (stroke-dasharray + animated dashoffset), so the
// logo redraws itself behind the gap while content loads — no spinner.
// Keyframes for `bba-travel` live in index.css.
const BBA_MARK_PATH =
  'M 83 83 L 115 51 A 21.21 21.21 0 1 0 85 51 L 117 83 L 149 115 A 21.21 21.21 0 1 0 149 85 L 117 117 L 85 149 A 21.21 21.21 0 1 0 115 149 L 83 117 L 51 85 A 21.21 21.21 0 1 0 51 115 L 83 83 Z';

const BBALoader = ({ size = 128, duration = 10, glow = true, className = '' }) => (
  <svg
    viewBox="0 0 200 200"
    width={size}
    height={size}
    className={className}
    style={glow ? { filter: `drop-shadow(0 0 ${Math.max(2, Math.round(size * 0.07))}px rgba(248,7,7,0.3))` } : undefined}
    role="status"
    aria-label="Loading"
  >
    <path
      pathLength="1000"
      d={BBA_MARK_PATH}
      style={{
        fill: 'none',
        stroke: '#f80707',
        strokeWidth: 5,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeDasharray: '860 140',
        animation: `bba-travel ${duration}s linear infinite`,
      }}
    />
  </svg>
);

export default BBALoader;
